export const AdminMenuList = [
    // Group: Dashboard
    { tab: 'Dashboard', icon: 'assets/icons/Dashboard.svg', navigateUrl: '/admin/useractivity', sequence: 1, roleid: '1', isSelected: false },
    { tab: 'Dashboard', icon: 'assets/icons/Dashboard.svg', navigateUrl: '/admin/useractivity', sequence: 1, roleid: '2', isSelected: false },
    { tab: 'Dashboard', icon: 'assets/icons/Dashboard.svg', navigateUrl: '/admin/useractivity', sequence: 1, roleid: '3', isSelected: false },
    { tab: 'Dashboard', icon: 'assets/icons/Dashboard.svg', navigateUrl: '/admin/useractivity', sequence: 1, roleid: '4', isSelected: false },
    { tab: 'Dashboard', icon: 'assets/icons/Dashboard.svg', navigateUrl: '/admin/useractivity', sequence: 1, roleid: '5', isSelected: false },
    // Commented code for Dashboard
    // { tab: 'Assessments / Surveys', icon: 'assets/icons/Survey.svg', navigateUrl: '/dashboard/mysurveydashboard', sequence: 2, roleid: '1', isSelected: false },
    // { tab: 'Assessments / Surveys', icon: 'assets/icons/Survey.svg', navigateUrl: '/dashboard/mysurveydashboard', sequence: 2, roleid: '2', isSelected: false },
    // { tab: 'Assessments / Surveys', icon: 'assets/icons/Survey.svg', navigateUrl: '/dashboard/mysurveydashboard', sequence: 2, roleid: '3', isSelected: false },
    // { tab: 'Assessments / Surveys', icon: 'assets/icons/Survey.svg', navigateUrl: '/dashboard/mysurveydashboard', sequence: 2, roleid: '4', isSelected: false },
    // { tab: 'Assessments / Surveys', icon: 'assets/icons/Survey.svg', navigateUrl: '/dashboard/mysurveydashboard', sequence: 2, roleid: '5', isSelected: false },

    // Group: Admin
    { tab: 'Admin', icon: 'assets/icons/Admin1.svg', navigateUrl: '/userManagement', sequence: 5, roleid: '1', isSelected: false },
    { tab: 'Admin', icon: 'assets/icons/Admin1.svg', navigateUrl: '/userManagement', sequence: 5, roleid: '4', isSelected: false },
    { tab: 'Admin', icon: 'assets/icons/Admin1.svg', navigateUrl: '/userManagement', sequence: 5, roleid: '5', isSelected: false },
    // Commented code for Admin
    // { tab: 'Templates', icon: 'assets/icons/Templates.svg', navigateUrl: '/dashboard/mytemplatedashboard', sequence: 8, roleid: '1', isSelected: false },
    // { tab: 'Templates', icon: 'assets/icons/Templates.svg', navigateUrl: '/dashboard/mytemplatedashboard', sequence: 8, roleid: '2', isSelected: false },
    // { tab: 'Templates', icon: 'assets/icons/Templates.svg', navigateUrl: '/dashboard/mytemplatedashboard', sequence: 8, roleid: '4', isSelected: false },
    // { tab: 'Templates', icon: 'assets/icons/Templates.svg', navigateUrl: '/dashboard/mytemplatedashboard', sequence: 8, roleid: '5', isSelected: false },

    // Group: Business Process
    { tab: 'Business process', icon: 'assets/icons/BusinessProcess1.svg', navigateUrl: '/dashboard/mybusinessprocesses', sequence: 6, roleid: '1', isSelected: false },
    { tab: 'Business process', icon: 'assets/icons/BusinessProcess1.svg', navigateUrl: '/dashboard/mybusinessprocesses', sequence: 6, roleid: '2', isSelected: false },
    { tab: 'Business process', icon: 'assets/icons/BusinessProcess1.svg', navigateUrl: '/businessProcess', sequence: 6, roleid: '3', isSelected: false },
    { tab: 'Business process', icon: 'assets/icons/BusinessProcess1.svg', navigateUrl: '/dashboard/mybusinessprocesses', sequence: 6, roleid: '4', isSelected: false },
    { tab: 'Business process', icon: 'assets/icons/BusinessProcess1.svg', navigateUrl: '/dashboard/mybusinessprocesses', sequence: 6, roleid: '5', isSelected: false },
    { tab: 'Business process', icon: 'assets/icons/BusinessProcess1.svg', navigateUrl: '/businessProcess', sequence: 1, roleid: '6', isSelected: false },
    { tab: 'Business process', icon: 'assets/icons/BusinessProcess1.svg', navigateUrl: '/dashboard/mybusinessprocesses', sequence: 2, roleid: '7', isSelected: false },

    // Group: Entity
    { tab: 'Entity', icon: 'assets/icons/Entity1.svg', navigateUrl: '/dashboard/myentities', sequence: 7, roleid: '1', isSelected: false },
    { tab: 'Entity', icon: 'assets/icons/Entity1.svg', navigateUrl: '/dashboard/myentities', sequence: 7, roleid: '2', isSelected: false },
    { tab: 'Entity', icon: 'assets/icons/Entity1.svg', navigateUrl: '/dashboard/myentities', sequence: 7, roleid: '4', isSelected: false },
    { tab: 'Entity', icon: 'assets/icons/Entity1.svg', navigateUrl: '/dashboard/myentities', sequence: 7, roleid: '5', isSelected: false },
    { tab: 'Entity', icon: 'assets/icons/Entity1.svg', navigateUrl: '/dashboard/myentities', sequence: 3, roleid: '7', isSelected: false },

    // Group: Dashboard Summary
    // { tab: 'Dashboard summary', icon: 'assets/icons/Dashboard.svg', navigateUrl: '/reports', sequence: 1, roleid: '1', isSelected: false },
    // { tab: 'Dashboard summary', icon: 'assets/icons/Dashboard.svg', navigateUrl: '/reports', sequence: 1, roleid: '2', isSelected: false },
    //{ tab: 'Dashboard summary', icon: 'assets/icons/Dashboard.svg', navigateUrl: '/reports', sequence: 1, roleid: '3', isSelected: false },
    // { tab: 'Dashboard summary', icon: 'assets/icons/Dashboard.svg', navigateUrl: '/reports', sequence: 1, roleid: '4', isSelected: false },
    // { tab: 'Dashboard summary', icon: 'assets/icons/Dashboard.svg', navigateUrl: '/reports', sequence: 1, roleid: '5', isSelected: false }

    ];

    export const RouteRoleConfig = [
        {
            navigateUrl: '/admin/useractivity',
            roles: ['Super Admin', 'Designer', 'Respondent', 'Group Admin', 'Organization Admin']
        },
        {
            navigateUrl: '/userManagement',
            roles: ['Super Admin', 'Group Admin', 'Organization Admin']
        },
        {
            navigateUrl: '/dashboard/mybusinessprocesses',
            roles: ['Super Admin', 'Designer', 'Group Admin', 'Organization Admin', 'Survey Admin']
        },
        {
            navigateUrl: '/businessProcess',
            roles: ['Respondent', 'Survey Respondent']
        },
        {
            navigateUrl: '/dashboard/myentities',
            roles: ['Super Admin', 'Designer', 'Group Admin', 'Organization Admin', 'Survey Admin']
        },
        {
            navigateUrl: '/reports',
            roles: ['Super Admin', 'Designer', 'Respondent', 'Group Admin', 'Organization Admin']
        },
    // Routes from create-routing.module.ts with roles
        {
            navigateUrl: '/create/createOrganization',
            roles: ['Super Admin']
        },
        {
            navigateUrl: '/create/createGroupUsers',
            roles: ['Super Admin']
        },
        {
            navigateUrl: '/create/createGroup',
            roles: ['Super Admin', 'Organization Admin']
        },
        {
            navigateUrl: '/create/createBusinessProcess',
            roles: ['Super Admin', 'Group Admin', 'Organization Admin', 'Designer']
        },
        {
            navigateUrl: '/create/entity',
            roles: ['Super Admin', 'Group Admin', 'Organization Admin', 'Designer']
        },
    // Routes from admin-routing.module.ts with admin roles
    {
        navigateUrl: '/admin/managegroups',
        roles: ['Super Admin', 'Group Admin', 'Organization Admin']
    },
    {
        navigateUrl: '/admin/manageorganizations',
        roles: ['Super Admin',  'Organization Admin']
    },
    {
        navigateUrl: '/admin/validationsettings',
        roles: ['Super Admin', 'Group Admin', 'Organization Admin']
    },
    {
        navigateUrl: '/admin/manageusers',
        roles: ['Super Admin', 'Group Admin', 'Organization Admin']
    },
    {
        navigateUrl: '/admin/managereports',
        roles: ['Super Admin', 'Group Admin', 'Organization Admin']
    },
    {
        navigateUrl: '/admin/useractivity',
        roles: ['Super Admin', 'Group Admin', 'Organization Admin']
    },
    {
        navigateUrl: '/admin/managevalidation',
        roles: ['Super Admin', 'Group Admin', 'Organization Admin']
    },
    {
        navigateUrl: '/admin/viewreport',
        roles: ['Super Admin', 'Group Admin', 'Organization Admin']
    },
    {
        navigateUrl: '/admin/sync',
        roles: ['Group Admin']
    },
    {
        navigateUrl: '/supervisor-mapping',
        roles: ['Super Admin', 'Group Admin', 'Organization Admin']
    },
];